import { DiagnosticsApi, useAPIQuery, useTable } from "melco-shared-logic";
import { isEmpty } from "lodash-es";
import { useTableErrorComponent } from "../table/useTableErrorComponent";

export const useGetLogsById = () => {

    const {
        filters,
        onTableConfigChange,
        searchQuery,
        searchQueryChange
    } = useTable()

    const query = useAPIQuery(DiagnosticsApi,
        ['logsById', filters, searchQuery],
        async (api: any) => {
            if (!isEmpty(searchQuery)) {
                const data = await api.diagnosticsGetLogsById({
                    id: !isEmpty(searchQuery) ? searchQuery : ""
                })
                return data
            }
            else {
                return []
            }
        },
        {
            queryOptions: {
                keepPreviousData: true
            }
        });


    const errorComponent = useTableErrorComponent(query.error, query.refetch);
    return {
        ...query,
        errorComponent,
        searchQuery,
        searchQueryChange,
        onTableConfigChange,
        filters
    }
    // const [getLogs] = useAPIAction(
    //     DiagnosticsApi,
    //     async (api, id: string) => {
    //         const data = await api.diagnosticsGetLogsById({ id, });

    //         return {
    //             successMessages: [{ message: "" }],
    //             data,
    //         };
    //     },
    //     {
    //         translationPrefix: "",
    //     }
    // );

    // return useCallback(
    //     async (logId: string) => {
    //         //const successfullyDeleted: string[] = [];


    //         try {
    //             return await getLogs(logId);
    //             // successfullyDeleted.push(logId);
    //         } catch (e) {
    //             // error handling is already done in useAPIAction
    //         }


    //         //return successfullyDeleted;
    //     },
    //     [getLogs]
    // );

};
